/* Progressive scroll enhancement: content is never hidden while waiting for JS. */
(function () {
  'use strict';
  if (window.__hdVisualPolish) return;
  window.__hdVisualPolish = true;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  var seen = new WeakSet();
  var active = new Set();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (motion.matches || (window.Shopify && window.Shopify.designMode)) return;
      var animation = entry.target.animate(
        [{ opacity: 0.65, transform: 'translateY(16px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 480, easing: 'cubic-bezier(.22,1,.36,1)' }
      );
      active.add(animation);
      animation.onfinish = animation.oncancel = function () { active.delete(animation); };
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -24px 0px' });
  function register(root) {
    var main = document.getElementById('MainContent') || document.querySelector('.hd-polish-content');
    if (!main || motion.matches || (window.Shopify && window.Shopify.designMode)) return;
    (root || main).querySelectorAll('h2, .hd-hc-vk__text, .hd-hc-vf__text, .hd-hc-promo__text, .hd-ba__text, .hd-p2c2__card').forEach(function (el) {
      if (seen.has(el) || !main.contains(el)) return;
      if (el.parentElement.closest('.hd-hc-vk__text, .hd-hc-vf__text, .hd-hc-promo__text, .hd-ba__text, .hd-p2c2__card')) return;
      if (el.closest('header, nav, dialog, [role="dialog"], .slick-cloned, details')) return;
      seen.add(el);
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      observer.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { register(); }, { once: true });
  else register();
  document.addEventListener('shopify:section:load', function (event) { register(event.target); });
  motion.addEventListener('change', function () {
    if (motion.matches) { observer.disconnect(); active.forEach(function (animation) { animation.cancel(); }); }
    else register();
  });
})();
